import React from "react";
import DataTable from "../../DataTable";
import { CorrespondentInfo } from "../../../types";
import { CORRESPONDENT_COLUMNS } from "../../../common/constants";
import styles from "../styles.module.scss";

interface Props {
  correspondents: CorrespondentInfo[];
  isLoading: boolean;
  csvPath: string;
}

const InstrumentCorrespondent = ({
  correspondents,
  isLoading,
  csvPath,
}: Props) => {
  return (
    <div id={"correspondent-table"} className={styles.table}>
      <DataTable
        tableData={correspondents ? correspondents : []}
        columns={CORRESPONDENT_COLUMNS}
        csvFileName={csvPath}
      />
    </div>
  );
};

export default InstrumentCorrespondent;
